export default {
  name: "CompareSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};